import { i18n } from '../../../i18n/i18n'

import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import labelBuilderService from '../../../services/labelBuilder.service'
import { RootState } from '../../../store'
import {
    FontStyle,
    replaceTextElementFontFamily,
    replaceTextElementFontSize,
    replaceTextElementFontStyle,
    replaceTextElementAlign,
    replaceTextElementDirection,
    replaceTextElementColor,
    replaceTextElementWidth,
    replaceTextElementHeight,
    replaceTextOpacity,
    TextElement,
    TextAlign,
    TextDirection
} from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import InputColor from '../../InputColor'
import Select from '../../Select'
import ContentProperty from './ContentProperty'
import InputText from '../../InputText'
import PositionProperty from './PositionProperty'

interface Props {
    selectedElement: TextElement
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class TextProperties extends Component<CombinedProps> {
    handleInputChange = (name: string, value: string) => {
        const { selectedElement } = this.props
        if (!selectedElement) return
        const { id } = selectedElement
        if (name === 'fontFamily') this.props.replaceTextElementFontFamily(id, value)
        if (name === 'fontSize') this.props.replaceTextElementFontSize(id, Number(value))
        if (name === 'opacity') this.props.replaceTextOpacity(id, Number(value))
        if (name === 'width') this.props.replaceTextElementWidth(id, value ? Number(value) : null)
        if (name === 'height') this.props.replaceTextElementHeight(id, value ? Number(value) : null)
        else if (name === 'fontStyle') this.props.replaceTextElementFontStyle(id, value as FontStyle)
        else if (name === 'align') this.props.replaceTextElementAlign(id, value as TextAlign)
        else if (name === 'direction') this.props.replaceTextElementDirection(id, value as TextDirection)
        else if (name === 'color') this.props.replaceTextElementColor(id, value)
    }

    render () {
        const { selectedElement } = this.props
        if (!selectedElement || selectedElement.type !== 'text') return
        return (
            <Fragment>
                <Heading
                    className="mb-1"
                    text={i18n('Text')}
                    size="small"/>
                <PositionProperty
                    elementId={selectedElement.id}
                    x={selectedElement.x}
                    y={selectedElement.y}
                />
                <div className="grid grid-cols-2 gap-4 mb-2">
                <InputText
                    type="number"
                    name="width"
                    value={selectedElement.width ? String(selectedElement.width) : ''}
                    label={'Maximum width (px)'}
                    placeholder={'Optional'}
                    onChange={this.handleInputChange}/>
                <InputText
                    type="number"
                    name="height"
                    value={selectedElement.height ? String(selectedElement.height) : ''}
                    label={'Maximum height (px)'}
                    placeholder={'Optional'}
                    onChange={this.handleInputChange}/>
                </div>
                <ContentProperty/>
                <div className="grid grid-cols-2 gap-4">
                    <Select
                        name="fontFamily"
                        value={selectedElement.font.family}
                        options={labelBuilderService.fontFamilySelectOptions}
                        label={i18n('Font family')}
                        onChange={this.handleInputChange}/>
                    <InputText
                        type="number"
                        name="fontSize"
                        value={String(selectedElement.font.size)}
                        label={i18n('Font size')}
                        onChange={this.handleInputChange}/>
                    <Select
                        name="fontStyle"
                        value={selectedElement.font.style}
                        options={labelBuilderService.fontStyleSelectOptions}
                        label={i18n('Font style')}
                        onChange={this.handleInputChange}/>
                    <Select
                        name="align"
                        value={selectedElement.align}
                        options={labelBuilderService.textAlignSelectOptions}
                        label={i18n('Text align')}
                        onChange={this.handleInputChange}/>
                    <Select
                        name="direction"
                        value={selectedElement.direction || 'ltr'}
                        options={labelBuilderService.textDirectionSelectOptions}
                        label="Text direction"
                        onChange={this.handleInputChange}/>
                    <InputText
                        type="number"
                        name="opacity"
                        value={String(selectedElement.opacity)}
                        label={i18n('Transparency')}
                        onChange={this.handleInputChange}
                        enforceLimits={true}/>
                    <InputColor
                        name="color"
                        value={selectedElement.font.color}
                        label="Color"
                        onChange={this.handleInputChange}/>
                </div>
            </Fragment>
        )
    }
}

function mapStateToProps (state: RootState) {
    return {}
}

const mapDispatchToProps = {
    replaceTextElementFontFamily,
    replaceTextElementFontSize,
    replaceTextElementFontStyle,
    replaceTextElementAlign,
    replaceTextElementDirection,
    replaceTextElementColor,
    replaceTextElementWidth,
    replaceTextElementHeight,
    replaceTextOpacity
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(TextProperties)
